import React from "react";
import "./ilona.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah";
import ilonadata from "./ilona.json";
import kalista from "../../../asset/newlaunch/kalista/kalista.js";
import kayla from "../../../asset/newlaunch/kayla/kayla.js";
import kirana from "../../../asset/newlaunch/kirana/kirana.js";
const imageMap = {
  kalista,
  kirana,
  kayla,

  // Add other image arrays here if you have more sets
};

const ilona = () => {
  return (
    <div className="ilona">
      <div className="container-ilona">
        <div className="header">
          <div className="judul-ilona">
            <div className="pink"></div>
            <span>Ilona Pasadena</span>
          </div>
        </div>
        <div className="cardhome-container">
          {ilonadata.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ilona;
